/**
 * After a deploy, cached entry bundles can request hashed chunks that no longer
 * exist. CloudFront SPA fallback then returns index.html, and dynamic import fails.
 * Reload once so the browser picks up the new index and matching assets.
 */

const RELOAD_KEY = 'heard:chunk-reload'

export function isChunkLoadFailure(reason: unknown): boolean {
  const message =
    reason instanceof Error
      ? reason.message
      : typeof reason === 'string'
        ? reason
        : String(reason ?? '')

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module')
  )
}

export function reloadOnceForStaleChunk(): boolean {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return false
  }

  if (sessionStorage.getItem(RELOAD_KEY) === '1') {
    sessionStorage.removeItem(RELOAD_KEY)
    return false
  }

  sessionStorage.setItem(RELOAD_KEY, '1')
  window.location.reload()
  return true
}

export function registerChunkLoadRecovery(): void {
  if (typeof window === 'undefined') {
    return
  }

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()
    reloadOnceForStaleChunk()
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadFailure(event.reason)) {
      return
    }
    if (reloadOnceForStaleChunk()) {
      event.preventDefault()
    }
  })
}
